import Constant from '@/const';
import axios from 'axios';

const getGoodsById = async id => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(`/master/goods/${id}`),
    );
    return response.data.data.detail;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default getGoodsById;
